// extracted by css-extract-rspack-plugin
export default {"label-scraps-link":"lSpUh9","labelScrapsLink":"lSpUh9"};